var IS_MAP_SENTINEL="@@__IMMUTABLE_MAP__@@";export default function isMap(maybeMap){return!!(maybeMap&&maybeMap[IS_MAP_SENTINEL])}
//# sourceMappingURL=is-immutable-map.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-map-gl/dist/esm/utils/is-immutable-map.js
// module id = 424
// module chunks = 0